import clonedeep from 'lodash.clonedeep'
import { ucFirst } from 'change-case'
import { toTitleCase } from '../../../../utils'
import { TemplateInputType } from './types'

// Converts an array into a multiline HTML string for rich text editors
export const convertValuesToMultiLine = (values, delimiter) => {
  if (!values || values.length === 0 || !Array.isArray(values)) return ''

  const newValues = clonedeep(values)
  newValues[0] = `${delimiter}${newValues[0]}`

  // Uses <br /> for newlines - works with all rich text editors
  return newValues.join(`<br />${delimiter}`)
}

// Special formatters for multi-value inputs
export const MULTIVALUE_FORMATTERS = {
  commaSeparated: values => {
    if (!values || values.length === 0 || !Array.isArray(values)) return ''

    return values.join(', ')
  },
  dashList: values => convertValuesToMultiLine(values, '- '),
  bulletList: values => convertValuesToMultiLine(values, '&bull; '),
  lineSeparatedList: values => convertValuesToMultiLine(values, '')
}

export const FORMATTERS = {
  none: v => v,
  titleCase: v => toTitleCase(v),
  upperCaseFirstWord: v => ucFirst(v),
  upperCaseAll: v => (v || '').toUpperCase(),
  lowerCaseAll: v => (v || '').toLowerCase()
}

export const MULTIVALUE_INPUT_TYPES: TemplateInputType[] = ['checkboxGroup' as TemplateInputType]

export const INPUT_CONFIG = {
  checkbox: {
    type: 'checkbox',
    readableName: 'Checkbox',
    defaultLayout: {
      w: 2,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      checked: false,
      value: false,
      alignRight: false,
      label: 'My Label'
    }
  },
  checkboxGroup: {
    type: 'checkboxGroup',
    readableName: 'Multiple Choice',
    defaultLayout: {
      w: 2,
      h: 1,
      maxH: 20
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      value: [],
      alignRight: false,
      label: 'My Label',
      options: [{ key: 'option 1', value: 'option 1' }]
    }
  },
  combobox: {
    type: 'combobox',
    readableName: 'Combo box',
    defaultLayout: {
      w: 4,
      minW: 3,
      maxH: 1,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      label: 'My Label',
      value: '',
      placeholder: 'Select option',
      required: false,
      options: [
        {
          key: 'option 1',
          value: 'option 1'
        }
      ]
    }
  },
  input: {
    type: 'input',
    readableName: 'Input',
    defaultLayout: {
      w: 2,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      label: 'My Label',
      value: '',
      placeholder: '',
      required: false
    }
  },
  numeric: {
    type: 'numeric',
    readableName: 'Numeric Input',
    defaultLayout: {
      w: 2,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      label: 'My Label',
      value: '',
      placeholder: '',
      min: 0,
      max: null,
      required: false
    }
  },
  radio: {
    type: 'radio',
    readableName: 'Radio Input',
    defaultLayout: {
      w: 3,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      label: 'My Label',
      inline: true,
      options: [
        {
          key: 'option 1',
          value: 'option 1'
        }
      ]
    }
  },
  select: {
    type: 'select',
    readableName: 'Dropdown',
    defaultLayout: {
      w: 2,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      label: 'My Label',
      options: [
        // {
        // key: '',
        // value: ''
        // }
      ]
    }
  },
  textarea: {
    type: 'textarea',
    readableName: 'Large Input',
    defaultLayout: {
      w: 3,
      h: 2
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      label: 'My Label',
      placeholder: '',
      required: false
    }
  },
  heading: {
    type: 'heading',
    readableName: 'Heading',
    defaultLayout: {
      w: 2,
      h: 1
    },
    props: {
      formatter: 'none',
      helpText: '',
      hidden: '',
      checked: false,
      value: false,
      alignRight: false,
      label: 'My Heading'
    }
  }
}

export const NON_REQUIREABLE_INPUT_TYPES = [INPUT_CONFIG.heading.type]
